import { useNavigate } from 'react-router-dom';
import { Person, Typography } from '@qapline/ui';

import { useAuth } from '../../hooks';

import styles from './UserInfo.module.scss';

export interface IUserInfoProps {
    userProfileUrl?: string;
    profilePictureUrl?: string;
}

export const UserInfo = ({ userProfileUrl, profilePictureUrl }: IUserInfoProps) => {
    const { user } = useAuth();
    const navigate = useNavigate();

    if (!user) {
        return null;
    }

    const handleClick = () => {
        if (!userProfileUrl) return;
        navigate(userProfileUrl);
    };

    return (
        <div
            className={styles.wrapper}
            onClick={handleClick}
            style={{ cursor: userProfileUrl ? 'pointer' : 'default' }}
        >
            {profilePictureUrl ? (
                <img src={profilePictureUrl} alt="" className={styles.profilePhoto} />
            ) : (
                <Person className={styles.profilePhoto} />
            )}
            <div className={styles.detailsWrapper}>
                <Typography variant="base14" fontWeight="bold" color="white">
                    {`${user.name} ${user.surname}`}
                </Typography>
                <Typography variant="base12" color="secondary">
                    {user.email}
                </Typography>
            </div>
        </div>
    );
};
